import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetUnderscoreLocale } from './recommendationAccessorGetUnderscoreLocale'

export const recommendationAccessorGetLocalizedProductUnit = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string | undefined =>
  product[
    `package_size_unit_${recommendationAccessorGetUnderscoreLocale(locale)}`
  ]
